import type { UserMarker } from "../store/myMarkers";

// ?marker=<id> (переход из «Я › Мои метки» на карту) -> сама метка или null.
export const markerFromQuery = (value: unknown, items: UserMarker[]): UserMarker | null => {
  const raw = Array.isArray(value) ? value[0] : value;
  const id = Number(raw);
  if (raw == null || raw === "" || !Number.isInteger(id)) return null;
  return items.find((m) => m.id === id) ?? null;
};
